import request from '@/utils/request'

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

export function sendSmsCode(phone) {
  return request({ url: '/auth/sms/send', method: 'post', data: { phone } })
}

export function smsLogin(data) {
  return request({ url: '/auth/sms/login', method: 'post', data })
}

export function wecomLogin(code) {
  return request({ url: '/auth/wecom/login', method: 'post', data: { code } })
}

export function getUserInfo() {
  return request({ url: '/auth/userinfo', method: 'get' })
}

export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

export function changePassword(data) {
  return request({ url: '/auth/changePassword', method: 'post', data })
}
